import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export default function GlobalAppFooter({ site }) {
  const s = site || {};
  return (
    <footer className="border-t-2 pf-border pf-surface mt-10 w-full max-w-full overflow-x-hidden" data-testid="global-app-footer">
      <div className="max-w-7xl mx-auto px-6 py-8 grid md:grid-cols-3 gap-6">
        <div>
          <div className="display text-xl font-bold">Ponderr</div>
          <p className="text-sm pf-muted mt-2">{s.footer_tagline || "One platform for schools, stores, TV & open learning."}</p>
          <div className="flex gap-3 mt-3">
            {s.social_facebook && <a href={s.social_facebook} className="underline text-sm">Facebook</a>}
            {s.social_instagram && <a href={s.social_instagram} className="underline text-sm">Instagram</a>}
            {s.social_youtube && <a href={s.social_youtube} className="underline text-sm">YouTube</a>}
          </div>
        </div>
        <div className="text-sm space-y-1">
          {s.footer_address && <div className="flex items-center gap-2"><MapPin size={14} /> {s.footer_address}</div>}
          {s.footer_phone && <div className="flex items-center gap-2"><Phone size={14} /> {s.footer_phone}</div>}
          {s.footer_email && <div className="flex items-center gap-2"><Mail size={14} /> {s.footer_email}</div>}
          <div className="flex gap-3 pt-2">
            <Link to="/store" className="underline" data-testid="footer-store">Storez</Link>
            <Link to="/tv" className="underline" data-testid="footer-tv">Ponderr TV</Link>
            <Link to="/posts" className="underline" data-testid="footer-posts">News &amp; Updates</Link>
          </div>
        </div>
        <div className="text-xs pf-muted space-y-2">
          <div className="flex gap-3 flex-wrap">
            <Link to="/terms" className="underline" data-testid="footer-terms">Terms of Service</Link>
            <Link to="/privacy" className="underline" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/data-deletion" className="underline" data-testid="footer-data-deletion">Data Deletion</Link>
          </div>
          <div>© {new Date().getFullYear()} Ponderr Platform.</div>
        </div>
      </div>
    </footer>
  );
}
